import ChallengeByApplicationStats from './ChallengeByApplicationStats';
import ChallengesByTopicStats from './ChallengesByTopicStats';
import TotalOpenChallengeStats from './TotalChallenges';

function OpenChallengesGraphs() {
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <TotalOpenChallengeStats />
      <ChallengesByTopicStats />
      <ChallengeByApplicationStats className="col-span-2" />
    </div>
  );
}

export default OpenChallengesGraphs;
